const API_BASE_URL = process.env.REACT_APP_SERVER_URL;

export const loginUser = async (email, password) => {
  const response = await fetch(`${API_BASE_URL}/users/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include', // ¡Crucial para cookies!
    body: JSON.stringify({ email, password }),
  });
  return response.json();
};
